/* Apotheken landing page. Form submissions and the thank-you view are handled
 * exclusively by the existing Jotform document; this script never submits data. */
(() => {
  'use strict';
  const root = document.querySelector('[data-kb-apotheken]');
  if (!root || root.dataset.initialized) return;
  root.dataset.initialized = 'true';
  const posImage = root.querySelector('#pos-image');
  root.querySelectorAll('[data-pos]').forEach(button => button.addEventListener('click', () => {
    const back = button.dataset.pos === 'hinten';
    if (!posImage) return;
    posImage.src = back ? posImage.dataset.posBack : posImage.dataset.posFront;
    posImage.alt = 'Vorhandener Kalter-Bruder-Aufsteller, ' + (back ? 'Rückseite' : 'Vorderseite');
    root.querySelectorAll('[data-pos]').forEach(other => other.setAttribute('aria-pressed', String(other === button)));
  }));

  const frame = root.querySelector('[data-kb-apotheken-jotform]');
  const formId = '262952539784372';
  const allowedOrigins = new Set([
    'https://form.jotform.com',
    'https://submit.jotform.com',
    'https://www.jotform.com',
    'https://jotform.com'
  ]);
  if (frame) {
    const informedOrigins = new Set();
    function sendParentLocation(origin) {
      if (informedOrigins.has(origin) || !frame.contentWindow) return;
      // The documented embed handshake supplies the host page location. Query
      // strings and fragments are deliberately excluded from this integration.
      const pageUrl = new URL(window.location.href);
      pageUrl.search = '';
      pageUrl.hash = '';
      let referrer = '';
      try { referrer = new URL(document.referrer).origin; } catch (_) { /* No referrer. */ }
      frame.contentWindow.postMessage(JSON.stringify({
        type: 'urls',
        value: { docurl: encodeURIComponent(pageUrl.href), referrer: encodeURIComponent(referrer) }
      }), origin);
      informedOrigins.add(origin);
    }
    frame.addEventListener('load', () => {
      informedOrigins.clear();
      sendParentLocation('https://form.jotform.com');
    });
    // Jotform's documented iframe protocol uses "setHeight:HEIGHT:FORM_ID".
    // Require both the exact sending frame and a known HTTPS origin. We do not
    // execute loadScript, reloadPage, redirect, or other arbitrary commands.
    window.addEventListener('message', event => {
      if (event.source !== frame.contentWindow || !allowedOrigins.has(event.origin)) return;
      sendParentLocation(event.origin);
      if (typeof event.data !== 'string' || event.data.length > 300) return;
      const parts = event.data.split(':');
      if (parts.length > 2 && parts[parts.length - 1] !== formId) return;
      if (parts[0] === 'setHeight' && /^\d+(?:\.\d+)?$/.test(parts[1] || '')) {
        const height = Number(parts[1]);
        if (Number.isFinite(height) && height > 0 && height <= 20000) {
          frame.style.height = Math.max(320, Math.ceil(height)) + 'px';
        }
      }
      // Keep validation errors and Jotform's own thank-you view reachable after
      // an intentional interaction; never jump the page merely on iframe load.
      if (parts[0] === 'scrollIntoView' && document.activeElement === frame) {
        frame.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  }

  const mobileCta = root.querySelector('#mobile-cta');
  const heroCta = root.querySelector('#hero-cta');
  const requestCard = root.querySelector('#request-card');
  if (!mobileCta || !heroCta || !requestCard || !('IntersectionObserver' in window)) return;
  const mobileViewport = window.matchMedia('(max-width: 650px)');
  const visibleActions = new Set();
  const contentActions = Array.from(root.querySelectorAll('a[href="#request-card"]'))
    .filter(action => !action.closest('header, .nav, #mobile-cta'));
  let heroPassed = false;
  let formVisible = false;
  function updateCta() {
    const visible = mobileViewport.matches && heroPassed && !formVisible &&
      visibleActions.size === 0 && !requestCard.contains(document.activeElement);
    mobileCta.classList.toggle('visible', visible);
    mobileCta.setAttribute('aria-hidden', String(!visible));
    mobileCta.inert = !visible;
  }
  // Observe only actions within the page content. The persistent navigation and
  // this floating action must not suppress the floating action themselves.
  const actionObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio > 0) visibleActions.add(entry.target);
      else visibleActions.delete(entry.target);
    });
    updateCta();
  }, { rootMargin: '0px 0px 70px 0px', threshold: [0, 0.01] });
  contentActions.forEach(action => actionObserver.observe(action));
  new IntersectionObserver(entries => {
    const entry = entries[0];
    heroPassed = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
    updateCta();
  }).observe(heroCta);
  new IntersectionObserver(entries => {
    formVisible = entries[0].isIntersecting;
    updateCta();
  }, { rootMargin: '50px' }).observe(requestCard);
  document.addEventListener('focusin', updateCta);
  document.addEventListener('focusout', () => requestAnimationFrame(updateCta));
  mobileViewport.addEventListener('change', updateCta);
  // IntersectionObserver re-evaluates on viewport changes without resize loops.
  updateCta();
})();

/* KB COMPLAINT EXPLORER MODULE */
/* Complaint topics progressively enhance ordinary anchors and visible articles. */
(() => {
  'use strict';
  const browser = document.querySelector('[data-concern-browser]');
  if (!browser || browser.dataset.ready) return;
  const tabs = Array.from(browser.querySelectorAll('[data-concern-tab]'));
  const panels = Array.from(browser.querySelectorAll('[data-concern-panel]'));
  if (tabs.length !== panels.length || !tabs.length) return;
  const nav = browser.querySelector('nav');
  nav.setAttribute('role','tablist');
  browser.dataset.ready = 'true';
  function select(index, focus = false) {
    tabs.forEach((tab, i) => {
      tab.setAttribute('aria-selected',String(i === index));
      tab.tabIndex = i === index ? 0 : -1;
      panels[i].hidden = i !== index;
    });
    if (focus) tabs[index].focus({preventScroll:true});
  }
  tabs.forEach((tab, index) => {
    tab.setAttribute('role','tab');
    tab.setAttribute('aria-controls',panels[index].id);
    panels[index].setAttribute('role','tabpanel');
    panels[index].setAttribute('aria-labelledby',tab.id);
    panels[index].tabIndex = 0;
    tab.addEventListener('click', event => {
      event.preventDefault(); select(index);
      if (window.matchMedia('(max-width:750px)').matches && panels[index].getBoundingClientRect().top > window.innerHeight * .5) {
        panels[index].scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
      }
    });
    tab.addEventListener('keydown', event => {
      let target = index;
      if (event.key === 'ArrowRight') target = (index + 1) % tabs.length;
      else if (event.key === 'ArrowLeft') target = (index + tabs.length - 1) % tabs.length;
      else if (event.key === 'ArrowDown') target = (index + 2) % tabs.length;
      else if (event.key === 'ArrowUp') target = (index + tabs.length - 2) % tabs.length;
      else if (event.key === 'Home') target = 0;
      else if (event.key === 'End') target = tabs.length - 1;
      else if (event.key === ' ') { event.preventDefault(); select(index); return; }
      else return;
      event.preventDefault(); select(target,true);
    });
  });
  const initial = panels.findIndex(panel => '#'+panel.id === window.location.hash);
  select(initial < 0 ? 0 : initial);
  browser.querySelectorAll('[data-concern-back]').forEach(button => button.addEventListener('click', () => {
    nav.scrollIntoView({block:'start',behavior:window.matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
    tabs.find(tab => tab.getAttribute('aria-selected') === 'true')?.focus({preventScroll:true});
  }));
  window.addEventListener('hashchange', () => {
    const index = panels.findIndex(panel => '#'+panel.id === window.location.hash);
    if (index >= 0) select(index);
  });
  browser.querySelectorAll('[data-concern-review]').forEach(link => link.addEventListener('click', event => {
    const summary = document.querySelector(link.getAttribute('href')+' summary');
    if (summary?.getAttribute('aria-haspopup') === 'dialog') {
      event.preventDefault();
      summary.click();
      const dialog = document.querySelector('[data-review-dialog]');
      dialog?.addEventListener('close', () => link.focus({preventScroll:true}), {once:true});
    }
  }));
})();
